import { render, staticRenderFns } from "./JobOfferBands.vue?vue&type=template&id=160834d9&scoped=true&"
import script from "./JobOfferBands.vue?vue&type=script&lang=js&"
export * from "./JobOfferBands.vue?vue&type=script&lang=js&"
import style0 from "./JobOfferBands.vue?vue&type=style&index=0&id=160834d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160834d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('160834d9')) {
      api.createRecord('160834d9', component.options)
    } else {
      api.reload('160834d9', component.options)
    }
    module.hot.accept("./JobOfferBands.vue?vue&type=template&id=160834d9&scoped=true&", function () {
      api.rerender('160834d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/JobOffers/JobOfferBands.vue"
export default component.exports